import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { UpdaterService } from './updater.service';

export function provideUpdater(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const updaterService = inject(UpdaterService);
    return updaterService.init();
  });
}
